import { parse } from "qs";
export const getPageQuery = () => parse(window.location.href.split("?")[1]);

/**
 * 将 Base64 编码的图片转换为 File 对象
 * @param {string} base64Data - Base64 编码的数据（包含 MIME 类型）
 * @param {string} filename - 文件名
 * @returns {Promise<File>} - 返回一个 Promise 对象，解析为 File 对象
 */
export function base64ToFile(base64Data, filename) {
  return new Promise((resolve, reject) => {
    // 分离 MIME 类型和 Base64 编码的数据
    const [header, base64] = base64Data.split(",");
    const mime = header.match(/:(.*?);/)[1];

    // 解码 Base64 数据
    const binaryString = window.atob(base64);
    const arrayBuffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    // 将解码的二进制数据写入 Uint8Array
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }

    // 创建 Blob 对象
    const blob = new Blob([uint8Array], { type: mime });

    // 创建 File 对象
    const file = new File([blob], filename, { type: mime });

    resolve(file);
  });
}

// 安全替换 Math.random()
export function secureRandom() {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] / (0xffffffff + 1);
}
